/**
 * @file Email Honeypot
 */
const vEmailHoneypot = () => {
  const emails = document.querySelectorAll('a[href^="mailto:"]');
  if ( emails.length ) {
    emails.forEach(( link ) =>  {
      const href = link.getAttribute('href');
      try {
        const email = atob(href.replace(/^mailto:/, ''));
        link.addEventListener('click', ( e ) => {
          window.location.href = `mailto:${email}`;
        });
      } catch(e) {
        const email = href.replace(/^mailto:/, '');
        const emailEncrypted = btoa(href.replace(/^mailto:/, ''));
        link.href = `mailto:${emailEncrypted}`;
        link.addEventListener('click', ( e ) => {
          window.location.href = `mailto:${email}`;
        });
      }
    });
  }

}

export default vEmailHoneypot;

